export const CREATE_EVENT = 'EVENT::CREATE_EVENT'
export const UPDATE_EVENT = 'EVENT::UPDATE_EVENT'
export const SET_EVENT_REQUEST_STATE = 'EVENT::SET_EVENT_STATE'
export const SET_USER_EVENTS = 'EVENT::SET_USER_EVENTS'
export const SET_USER_EVENT_DETAIL = 'EVENT::SET_USER_EVENT_DETAIL'
export const SET_USER_REQUESTS = 'EVENT::SET_USER_REQUESTS'
export const SET_USER_OFFERS = 'EVENT::SET_USER_OFFERS'
export const SET_NON_USER_REQUESTS = 'EVENT::SET_NON_USER_REQUESTS'
export const SET_NON_USER_OFFERS = 'EVENT::SET_NON_USER_OFFERS'
export const DELETE_EVENT = 'EVENT::DELETE_EVENT'

export const SET_SHOW_NEXT_PAGE = 'EVENT::SET_SHOW_NEXT_PAGE'
export const SET_SHOW_PREV_PAGE = 'EVENT::SET_SHOW_PREV_PAGE'
export const TOGGLE_SHOW_ALL = 'EVENT::TOGGLE_SHOW_ALL'

export const TOGGLE_CATEGORY = 'EVENT::TOGGLE_CATEGORY'
export const SET_ALL_CATEGORIES = 'EVENT::SET_ALL_CATEGORIES'
export const RESET_CATEGORY = 'EVENT::RESET_CATEGORY'

export const SET_SEARCH_TEXT = 'EVENT::SET_SEARCH_TEXT'
export const SET_USER_PROFILE_SELECTED_TAB =
  'EVENT::SET_USER_PROFILE_SELECTED_TAB'
export const SET_FEED_SELECTED_TAB = 'EVENT::SET_FEED_SELECTED_TAB'
export const SET_EVENT_ATTENDEES = 'EVENT::SET_EVENT_ATTENDEES'

export const SET_EVENT_REQUEST_START = 'EVENT::SET_EVENT_REQUEST_START'
export const SET_EVENT_REQUEST_SUCCESS = 'EVENT::SET_EVENT_REQUEST_SUCCESS'
export const UPDATE_EVENT_REQUEST_PROGRESS =
  'EVENT::UPDATE_EVENT_REQUEST_PROGRESS'
export const RESET_EVENT_REQUEST = 'EVENT::RESET_EVENT_REQUEST'
